// src/pages/ReleasesTestes.jsx
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import MainLayout from "../components/mainLayout";
import { api } from "../api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  Search,
  RefreshCw,
  ArrowUpDown,
  ChevronLeft,
  ChevronRight,
  HelpCircle,
  Download,
  ShieldCheck,
  ShieldOff,
  AlertTriangle,
  X,
  CheckCircle2,
  XCircle,
  Plus,
  Trash2,
  Save,
  MonitorUp,
  Loader2,
  Users,
  ListChecks,
  Eraser,
  Globe2,
} from "lucide-react";
import { showError, showInfo } from "../utils/toast";
import HelpBar from "../components/HelpBar";
import HelpModal from "../components/HelpModal";
import SelectCliente from "../components/ui/selectCliente";
import "../sass/pages/releasesTestes.scss";

const S = (v) => (v == null ? "" : String(v).trim());

const PARAMETRO_ATUALIZACAO = "372";
const GRUPO_PARAMETRO_PADRAO = "Atualização sistema";

const CODIGO_FORA_JANELA_GLOBAL = "FORA_JANELA_ATUALIZACAO_GLOBAL";
const TEXTO_JANELA_GLOBAL =
  "segunda a quinta-feira, das 08:00 às 13:59";

const getMsgErroApi = (err, fallback) =>
  err?.response?.data?.message ||
  err?.response?.data?.mensagem ||
  err?.response?.data?.error ||
  err?.message ||
  fallback;

const montarBloqueioJanelaGlobal = (err) => {
  const data = err?.response?.data || {};

  if (data?.code !== CODIGO_FORA_JANELA_GLOBAL) {
    return null;
  }

  return {
    code: data.code,
    message:
      data.message ||
      `Liberação global bloqueada. Permitido somente de ${TEXTO_JANELA_GLOBAL}.`,
    janela: data.janela || null,
    permiteSelecionados: data.permiteSelecionados !== false,
    permiteAgendamento: data.permiteAgendamento === true,
  };
};

const formatarDetalheJanela = (janela) => {
  if (!janela) return "";

  const partes = [];

  if (janela.diaSemanaNome) partes.push(janela.diaSemanaNome);
  if (janela.dataLocal) partes.push(janela.dataLocal);
  if (janela.horaLocal) partes.push(janela.horaLocal);
  if (janela.motivo) partes.push(`motivo: ${janela.motivo}`);

  return partes.join(" • ");
};

const fmtBytes = (n) => {
  const v = Number(n);
  if (!Number.isFinite(v)) return "—";
  if (v < 1024) return `${v} B`;
  if (v < 1024 * 1024) return `${(v / 1024).toFixed(1)} KB`;
  return `${(v / (1024 * 1024)).toFixed(1)} MB`;
};

const fmtDateTime = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return String(s);
  return d.toLocaleString("pt-BR");
};

// const absURL = (path) => {
//   const base = api?.defaults?.baseURL || window.location.origin;
//   const u = new URL(base);
//   const basePath = u.pathname.replace(/\/+$/, "");
//   if (path.startsWith("/")) return `${u.origin}${path}`;
//   return `${u.origin}${basePath ? basePath + "/" : "/"}${path}`;
// };

const safeParse = (raw) => {
  try {
    return JSON.parse(raw || "{}");
  } catch {
    return {};
  }
};

const getStorageValue = (key) =>
  (sessionStorage.getItem(key) ?? localStorage.getItem(key) ?? "").trim();

const getUserNameFromStorage = () => {
  try {
    const direct =
      getStorageValue("RazaoSocial") ||
      getStorageValue("NomeFunc") ||
      getStorageValue("name");

    if (direct) return direct;

    const u = {
      ...safeParse(sessionStorage.getItem("user")),
      ...safeParse(localStorage.getItem("user")),
    };

    return (u.RazaoSocial || u.nome || u.name || u.NomeFunc || "")
      .toString()
      .trim();
  } catch {
    return "";
  }
};

const COD_PARAMETRO_TECNICO_ATUALIZACAO =
  "PERMITIR_ATUALIZACAO_SISTEMA";

const FRASE_CONFIRMACAO_ATUALIZACAO =
  "CONFIRMO ALTERAR PERMITIR_ATUALIZACAO_SISTEMA";

const normalizarNivelParametro = (valor) => {
  const nivel = Number(valor);

  if (!Number.isInteger(nivel) || nivel < 0 || nivel > 5) {
    return 0;
  }

  return nivel;
};

const getNivelParametroFromStorage = () => {
  try {
    const direto =
      getStorageValue("NivelParametro") ||
      getStorageValue("nivelParametro");

    if (direto !== "") {
      return normalizarNivelParametro(direto);
    }

    const u = {
      ...safeParse(sessionStorage.getItem("user")),
      ...safeParse(localStorage.getItem("user")),
    };

    return normalizarNivelParametro(
      u.NivelParametro ??
      u.nivelParametro ??
      0
    );
  } catch {
    return 0;
  }
};

const getTokenFromStorage = () =>
  sessionStorage.getItem("token") ||
  localStorage.getItem("token") ||
  "";

const garantirBearerApi = () => {
  const token = String(getTokenFromStorage() || "").trim();

  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  return token;
};

const getNivelMutacaoCatalogo = (catalogo = {}) =>
  Number(catalogo.NIVEL_MUTACAO ?? catalogo.nivelMutacao ?? 1) || 1;

const flagSimGovernanca = (valor) =>
  String(valor ?? "").trim().toUpperCase() === "S";

const getCodigoTecnicoCatalogo = (catalogo = {}) =>
  S(
    catalogo.COD_PARAMETRO_TECNICO ??
    catalogo.codParametroTecnico ??
    catalogo.codigoTecnico
  );

const getNumeroParametroLegadoCatalogo = (catalogo = {}) =>
  S(
    catalogo.NR_PARAMETRO_LEGADO ??
    catalogo.nrParametroLegado ??
    catalogo.NM_PARAMETRO_LEGADO ??
    catalogo.nmParametroLegado
  );

const parametroExigeJustificativa = (catalogo = {}) =>
  flagSimGovernanca(
    catalogo.EXIGE_JUSTIFICATIVA ?? catalogo.exigeJustificativa
  ) || getNivelMutacaoCatalogo(catalogo) >= 2;

const parametroExigeConfirmacao = (catalogo = {}) =>
  flagSimGovernanca(
    catalogo.EXIGE_CONFIRMACAO_TEXTUAL ?? catalogo.exigeConfirmacaoTextual
  ) || getNivelMutacaoCatalogo(catalogo) >= 3;

const getFraseConfirmacaoCatalogo = (catalogo = {}) => {
  const frase = S(
    catalogo.FRASE_CONFIRMACAO ?? catalogo.fraseConfirmacao
  );

  if (frase) return frase;

  if (getNivelMutacaoCatalogo(catalogo) >= 5) {
    return "CONFIRMO ALTERACAO CRITICA NIVEL 5";
  }

  const codigo =
    getCodigoTecnicoCatalogo(catalogo) ||
    COD_PARAMETRO_TECNICO_ATUALIZACAO;

  return `CONFIRMO ALTERAR ${codigo}`;
};

const normalizarSimNao = (v) => {
  const s = S(v).toUpperCase();

  if (s === "S" || s === "SIM") return "Sim";
  if (s === "N" || s === "NAO" || s === "NÃO") return "Não";

  return S(v);
};

const getCodigoCliente = (cliente) => {
  if (!cliente) return "";

  return S(
    cliente.CodigoCad ||
      cliente.codigo ||
      cliente.codCad ||
      cliente.CODIGO ||
      cliente.ID ||
      cliente.id
  );
};

const getClienteNome = (cliente) => {
  if (!cliente) return "";

  return [
    S(cliente.CodigoCad || cliente.codigo || cliente.codCad),
    S(cliente.RazaoSocial || cliente.NomeFant || cliente.nome || cliente.NOME),
  ]
    .filter(Boolean)
    .join(" - ");
};

const getPcId = (pc) =>
  S(
    pc?.ID_COMPUTADOR ||
      pc?.TOKEN_COMPUTADOR ||
      pc?.idComputador ||
      pc?.tokenComputador ||
      pc?.id_computador ||
      pc?.token_computador
  );

const getPcNome = (pc) =>
  S(
    pc?.NM_COMPUTADOR ||
      pc?.NOME_COMPUTADOR ||
      pc?.nomeComputador ||
      pc?.nome_computador ||
      pc?.IDENTIFICADOR ||
      pc?.identificador
  );

const getPcPdv = (pc) => S(pc?.NR_PDV ?? pc?.nrPdv ?? pc?.pdv ?? "");

const isPcAtivo = (pc) => {
  const v = S(pc?.DM_ATIVO || pc?.dmAtivo || pc?.ativo).toUpperCase();
  if (!v) return true;
  return ["S", "SIM", "TRUE", "1", "ATIVO"].includes(v);
};

const chaveComputador372 = (item) =>
  `${S(item.nrLicenca)}|${S(item.idComputador)}|${S(item.grupoParametro)}`;

const classeSimNao = (v) => {
  const x = normalizarSimNao(v);
  if (x === "Sim") return "yes";
  if (x === "Não") return "no";
  return "unknown";
};

const RELEASE_PRODUTOS = [
  { key: "SPW", label: "SPW" },
  { key: "VB6", label: "VB6" },
  { key: "DLL", label: "DLL" },
];

const StatusOpts = ["EM_TESTE", "APROVADO", "REPROVADO", "INATIVO"];

function StatusBadge({ value }) {
  const map = {
    EM_TESTE: { bg: "#fef9c3", fg: "#854d0e", label: "Em teste" },
    APROVADO: { bg: "#dcfce7", fg: "#166534", label: "Aprovado" },
    REPROVADO: { bg: "#fee2e2", fg: "#991b1b", label: "Reprovado" },
    INATIVO: { bg: "#e5e7eb", fg: "#374151", label: "Inativo" },
  };

  const c = map[value] || {
    bg: "#f3f4f6",
    fg: "#374151",
    label: value || "-",
  };

  return (
    <span
      style={{
        background: c.bg,
        color: c.fg,
        border: "1px solid rgba(0,0,0,.06)",
        borderRadius: 999,
        fontSize: 12,
        padding: "2px 8px",
        lineHeight: "18px",
        fontWeight: 700,
        whiteSpace: "nowrap",
      }}
    >
      {c.label}
    </span>
  );
}

function ActiveBadge({ ativa }) {
  if (!ativa) return <span className="badge-prod off">Homologação</span>;
  return <span className="badge-prod on">Produção</span>;
}

function ReleasesModal({
  open,
  onClose,
  title,
  icon,
  children,
  footer,
  className = "",
}) {
  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  return (
    <div
      className="releases-modal-backdrop"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`releases-modal ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="releases-modal-header">
          <div className="releases-modal-title">
            {icon && <span className="releases-modal-icon">{icon}</span>}
            <span>{title}</span>
          </div>

          <button
            type="button"
            className="icon-btn"
            onClick={onClose}
            aria-label="Fechar"
          >
            <X size={18} />
          </button>
        </div>

        <div className="releases-modal-body">{children}</div>

        {footer && <div className="releases-modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

function useQuerySync(defaults) {
  const loc = useLocation();
  const params = useMemo(() => new URLSearchParams(loc.search), [loc.search]);

  const get = useCallback((key) => params.get(key), [params]);

  const setMany = useCallback(
    (patch) => {
      const next = new URLSearchParams(loc.search);

      Object.entries(patch).forEach(([k, v]) => {
        if (v === undefined || v === null || v === "" || v === false) {
          next.delete(k);
        } else {
          next.set(k, String(v));
        }
      });

      window.history.replaceState(
        null,
        "",
        `${loc.pathname}?${next.toString()}`
      );
    },
    [loc.pathname, loc.search]
  );

  const initial = useMemo(() => {
    const obj = { ...defaults };

    Object.keys(defaults).forEach((k) => {
      const v = get(k);

      if (v !== null) {
        if (k === "page" || k === "limit") obj[k] = Number(v) || defaults[k];
        else if (k === "onlyActive") obj[k] = v === "1" || v === "true";
        else obj[k] = v;
      }
    });

    return obj;
  }, [defaults, get]);

  return { initial, setMany };
}

const normalizeResult = (payload) => {
  if (Array.isArray(payload)) {
    return { rows: payload, total: payload.length };
  }

  const rows = payload?.data ?? payload?.rows ?? payload?.items ?? [];
  const total = Number(payload?.total ?? payload?.count ?? rows.length ?? 0);

  return { rows: Array.isArray(rows) ? rows : [], total };
};

function AtualizacaoSistemaModal({
  open,
  onClose,
  nivelParametroUsuario,
}) {
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [computadoresBusca, setComputadoresBusca] = useState([]);
  const [loadingComputadores, setLoadingComputadores] = useState(false);

  const [checkedKeys, setCheckedKeys] = useState([]);
  const [destinosPorKey, setDestinosPorKey] = useState({});
  const [itensAlteracao, setItensAlteracao] = useState([]);

  const [modoAplicacao, setModoAplicacao] = useState("SELECIONADOS");
  const [valorTodos, setValorTodos] = useState("Sim");

  const [aplicando, setAplicando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [bloqueioGlobal, setBloqueioGlobal] = useState(null);
  const [confirmacaoGlobalOpen, setConfirmacaoGlobalOpen] = useState(false);
  const [justificativaSelecionados, setJustificativaSelecionados] = useState(
    "Liberação controlada de atualização automática para computadores selecionados."
  );
  const [confirmacaoSelecionados, setConfirmacaoSelecionados] = useState(
    FRASE_CONFIRMACAO_ATUALIZACAO
  );
  const [justificativaGlobal, setJustificativaGlobal] = useState(
    "Liberação global controlada de atualização automática do sistema."
  );
  const [confirmacaoGlobal, setConfirmacaoGlobal] = useState(
    FRASE_CONFIRMACAO_ATUALIZACAO
  );

  const [catalogo372, setCatalogo372] = useState(null);
  const [loadingGovernanca372, setLoadingGovernanca372] = useState(false);
  const [erroGovernanca372, setErroGovernanca372] = useState("");

  const nivelMutacao372 = catalogo372
    ? getNivelMutacaoCatalogo(catalogo372)
    : null;

  const permiteAlteracaoLote372 = catalogo372
    ? flagSimGovernanca(
        catalogo372.PERMITE_ALTERACAO_LOTE ??
        catalogo372.permiteAlteracaoLote
      )
    : false;

  const podeAlterar372 =
    nivelMutacao372 != null &&
    normalizarNivelParametro(nivelParametroUsuario) >= nivelMutacao372;

  const exigeJustificativa372 = catalogo372
    ? parametroExigeJustificativa(catalogo372)
    : false;

  const exigeConfirmacao372 = catalogo372
    ? parametroExigeConfirmacao(catalogo372)
    : false;

  const fraseConfirmacao372 = catalogo372
    ? getFraseConfirmacaoCatalogo(catalogo372)
    : FRASE_CONFIRMACAO_ATUALIZACAO;

  const codParametroTecnico372 = catalogo372
    ? getCodigoTecnicoCatalogo(catalogo372) ||
      COD_PARAMETRO_TECNICO_ATUALIZACAO
    : COD_PARAMETRO_TECNICO_ATUALIZACAO;

  useEffect(() => {
    if (!open) return;

    garantirBearerApi();

    let ativo = true;

    const carregarGovernanca = async () => {
      setLoadingGovernanca372(true);
      setErroGovernanca372("");

      try {
        const { data } = await api.get(
          "/ssw/parametros-governanca/catalogo",
          { params: { ativo: "S", limit: 500 } }
        );

        const lista = Array.isArray(data)
          ? data
          : data?.data || data?.rows || [];

        const hit = (Array.isArray(lista) ? lista : []).find((item) => {
          const codigo = getCodigoTecnicoCatalogo(item).toUpperCase();
          const legado = getNumeroParametroLegadoCatalogo(item).toUpperCase();

          return (
            codigo === COD_PARAMETRO_TECNICO_ATUALIZACAO.toUpperCase() ||
            legado === PARAMETRO_ATUALIZACAO
          );
        });

        if (!hit) {
          throw new Error(
            "Parâmetro 372 não encontrado no catálogo de governança."
          );
        }

        if (!ativo) return;

        setCatalogo372(hit);

        const frase = parametroExigeConfirmacao(hit)
          ? getFraseConfirmacaoCatalogo(hit)
          : "";

        setConfirmacaoSelecionados(frase);
        setConfirmacaoGlobal(frase);
      } catch (err) {
        if (!ativo) return;

        setCatalogo372(null);
        setErroGovernanca372(
          getMsgErroApi(
            err,
            "Não foi possível carregar a governança do parâmetro 372."
          )
        );
      } finally {
        if (ativo) setLoadingGovernanca372(false);
      }
    };

    carregarGovernanca();

    return () => {
      ativo = false;
    };
  }, [open]);

  const totalSelecionadosBusca = checkedKeys.length;
  const totalLista = itensAlteracao.length;
  const totalSim = itensAlteracao.filter((x) => x.vlParametro === "Sim").length;
  const totalNao = itensAlteracao.filter((x) => x.vlParametro === "Não").length;

  const limparBusca = () => {
    setClienteSelecionado(null);
    setComputadoresBusca([]);
    setCheckedKeys([]);
    setDestinosPorKey({});
    setBloqueioGlobal(null);
  };

  const buscarComputadoresCliente = useCallback(async (cliente) => {
    const codigoCliente = getCodigoCliente(cliente);

    if (!codigoCliente) {
      setComputadoresBusca([]);
      setCheckedKeys([]);
      setDestinosPorKey({});
      showError("Cliente sem código para buscar computadores.");
      return;
    }

    setLoadingComputadores(true);
    setComputadoresBusca([]);
    setCheckedKeys([]);
    setDestinosPorKey({});
    setResultado(null);
    setBloqueioGlobal(null);

    try {
      const { data } = await api.get(
        `/ssw/computador/${encodeURIComponent(codigoCliente)}`
      );

      const computadores = Array.isArray(data) ? data : data?.data || [];

      let parametros372 = [];

      try {
        const respParam = await api.get(
          `/ssw/parametros-atualizacao-sistema/computadores/${encodeURIComponent(
            codigoCliente
          )}`
        );

        parametros372 = Array.isArray(respParam?.data?.dados)
          ? respParam.data.dados
          : [];
      } catch (errParam) {
        console.warn(
          "[PARAM-372] Não foi possível enriquecer computadores com valor atual.",
          errParam
        );
      }

      const mapaParametro = new Map();

      parametros372.forEach((p) => {
        const id = S(p.idComputador || p.ID_COMPUTADOR);
        if (!id) return;

        mapaParametro.set(id, {
          grupoParametro: S(p.grupoParametro || p.GRUPO_PARAMETRO),
          valorAtual: normalizarSimNao(p.valorAtual || p.VL_PARAMETRO),
          descricao: S(p.descricao || p.DS_PARAMETRO),
          identificador: S(p.identificador || p.IDENTIFICADOR),
        });
      });

      const normalizados = computadores
        .map((pc) => {
          const idComputador = getPcId(pc);
          if (!idComputador) return null;

          const param = mapaParametro.get(idComputador);

          const valorAtualParam = normalizarSimNao(param?.valorAtual);
          const valorAtual = valorAtualParam || "—";

          const destinoInicial =
            valorAtual === "Sim" || valorAtual === "Não" ? valorAtual : "Sim";

          return {
            nrLicenca: codigoCliente,
            idComputador,
            grupoParametro: param?.grupoParametro || GRUPO_PARAMETRO_PADRAO,
            nmParametro: PARAMETRO_ATUALIZACAO,
            valorAtual,
            descricao:
              param?.descricao || "Permitir sistema atualizar automaticamente?",
            identificador:
              param?.identificador || getPcNome(pc) || getPcPdv(pc) || "—",
            nomeComputador: getPcNome(pc),
            nrPdv: getPcPdv(pc),
            ativo: isPcAtivo(pc),
            clienteNome: getClienteNome(cliente),
            vlParametroDestino: destinoInicial,
          };
        })
        .filter(Boolean);

      const destinos = {};

      normalizados.forEach((item) => {
        destinos[chaveComputador372(item)] = item.vlParametroDestino;
      });

      setComputadoresBusca(normalizados);
      setDestinosPorKey(destinos);

      if (!normalizados.length) {
        showInfo("Nenhum computador encontrado para este cliente.");
      }
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.mensagem ||
        err?.response?.data?.error ||
        err?.message ||
        "Falha ao buscar computadores do cliente.";

      showError(msg);
    } finally {
      setLoadingComputadores(false);
    }
  }, []);

  const handleClienteChange = (cliente) => {
    setClienteSelecionado(cliente);

    if (!cliente) {
      limparBusca();
      return;
    }

    buscarComputadoresCliente(cliente);
  };

  const toggleChecked = (key) => {
    setCheckedKeys((prev) =>
      prev.includes(key) ? prev.filter((x) => x !== key) : [...prev, key]
    );
  };

  const marcarTodosBusca = () => {
    setCheckedKeys(computadoresBusca.map(chaveComputador372));
  };

  const desmarcarTodosBusca = () => {
    setCheckedKeys([]);
  };

  const aplicarDestinoTodosBusca = (valor) => {
    const next = { ...destinosPorKey };

    computadoresBusca.forEach((item) => {
      next[chaveComputador372(item)] = valor;
    });

    setDestinosPorKey(next);
  };

  const alterarDestinoLinha = (item, valor) => {
    const key = chaveComputador372(item);

    setDestinosPorKey((prev) => ({
      ...prev,
      [key]: valor,
    }));
  };

  const adicionarSelecionadosNaLista = () => {
    if (!checkedKeys.length) {
      showError("Selecione ao menos um computador para adicionar à lista.");
      return;
    }

    const selecionados = computadoresBusca.filter((item) =>
      checkedKeys.includes(chaveComputador372(item))
    );

    const map = new Map();

    itensAlteracao.forEach((item) => {
      map.set(chaveComputador372(item), item);
    });

    selecionados.forEach((item) => {
      const key = chaveComputador372(item);
      const valorDestino = normalizarSimNao(destinosPorKey[key]) || "Sim";

      map.set(key, {
        ...item,
        vlParametro: valorDestino,
      });
    });

    setItensAlteracao(Array.from(map.values()));
    setCheckedKeys([]);

    showInfo(`${selecionados.length} computador(es) adicionados à lista.`);
  };

  const removerItemLista = (item) => {
    const key = chaveComputador372(item);
    setItensAlteracao((prev) =>
      prev.filter((x) => chaveComputador372(x) !== key)
    );
  };

  const alterarDestinoLista = (item, valor) => {
    const key = chaveComputador372(item);

    setItensAlteracao((prev) =>
      prev.map((x) =>
        chaveComputador372(x) === key
          ? {
              ...x,
              vlParametro: normalizarSimNao(valor),
            }
          : x
      )
    );
  };

  const limparLista = () => {
    if (!itensAlteracao.length) return;

    const ok = window.confirm("Deseja limpar toda a lista de alterações?");
    if (!ok) return;

    setItensAlteracao([]);
    setResultado(null);
    setBloqueioGlobal(null);
  };

  const aplicarSelecionados = async () => {
    if (!itensAlteracao.length) {
      showError("Nenhum computador na lista para atualização.");
      return;
    }

    if (loadingGovernanca372) {
      showError("Aguarde o carregamento da governança do parâmetro 372.");
      return;
    }

    if (!catalogo372) {
      showError(
        erroGovernanca372 ||
        "Governança do parâmetro 372 indisponível. A alteração foi bloqueada."
      );
      return;
    }

    if (!podeAlterar372) {
      showError(
        `Sem permissão para alterar o parâmetro 372. Necessário N${nivelMutacao372}; seu nível é N${normalizarNivelParametro(
          nivelParametroUsuario
        )}.`
      );
      return;
    }

    const justificativa = S(justificativaSelecionados);
    const confirmacao = S(confirmacaoSelecionados);

    if (exigeJustificativa372 && !justificativa) {
      showError("Informe a justificativa da alteração governada.");
      return;
    }

    if (
      exigeConfirmacao372 &&
      confirmacao !== fraseConfirmacao372
    ) {
      showError(
        `Confirmação textual inválida. Digite exatamente: ${fraseConfirmacao372}`
      );
      return;
    }

    const ok = window.confirm(
      `Confirma aplicar o parâmetro 372 via governança para ${itensAlteracao.length} computador(es)?\n\nEssa ação grava auditoria, materializa no legado e atualiza/cria sync pendente para os PDVs selecionados.`
    );

    if (!ok) return;

    setAplicando(true);
    setResultado(null);
    setBloqueioGlobal(null);

    garantirBearerApi();
    const resultados = [];

    try {
      for (const item of itensAlteracao) {
        const valor = normalizarSimNao(item.vlParametro) || "Sim";

        try {
          const { data: alteracao } = await api.post(
            "/ssw/parametros-governanca/alterar",
            {
              codParametroTecnico: codParametroTecnico372,
              escopo: "COMPUTADOR",
              nrLicenca: item.nrLicenca,
              idComputador: item.idComputador,
              valorNovo: valor,
              justificativa,
              textoConfirmacao: confirmacao,
            },
            {
              timeout: 120000,
            }
          );

          const { data: materializacao } = await api.post(
            "/ssw/parametros-governanca/materializar",
            {
              codParametroTecnico: codParametroTecnico372,
              escopo: "COMPUTADOR",
              nrLicenca: item.nrLicenca,
              idComputador: item.idComputador,
              dryRun: false,
            },
            {
              timeout: 120000,
            }
          );

          resultados.push({
            nrLicenca: item.nrLicenca,
            idComputador: item.idComputador,
            valorDestino: valor,
            status: "OK",
            idParametroValor: alteracao?.idParametroValor || null,
            syncId: materializacao?.syncGerados ?? materializacao?.syncOperacoes ?? "—",
            syncGerados:
              Number(
                materializacao?.syncGerados ??
                  materializacao?.syncOperacoes ??
                  materializacao?.syncInseridos ??
                  0
              ) || 0,
            alterados: Number(materializacao?.alterados || 0),
          });
        } catch (errItem) {
          resultados.push({
            nrLicenca: item.nrLicenca,
            idComputador: item.idComputador,
            valorDestino: valor,
            status: "ERRO",
            syncId: "—",
            erro: getMsgErroApi(errItem, "Falha ao aplicar governança."),
          });
        }
      }

      const totalErro = resultados.filter((x) => x.status === "ERRO").length;
      const totalAtualizado = resultados.reduce(
        (acc, x) => acc + Number(x.alterados || 0),
        0
      );
      const totalSyncGerado = resultados.reduce(
        (acc, x) => acc + Number(x.syncGerados || 0),
        0
      );

      const data = {
        ok: totalErro === 0,
        origem: "GOVERNANCA",
        totalRecebido: itensAlteracao.length,
        totalProcessado: resultados.length,
        totalAtualizado,
        totalSyncGerado,
        totalErro,
        resultados,
      };

      setResultado(data);

      if (totalErro > 0) {
        showError(`Processo concluído com ${totalErro} erro(s).`);
      } else {
        showInfo(
          `Alterações aplicadas via governança. Operações de sync: ${totalSyncGerado}.`
        );
      }
    } finally {
      setAplicando(false);
    }
  };

  const abrirConfirmacaoGlobal = () => {
    if (loadingGovernanca372) {
      showError("Aguarde o carregamento da governança do parâmetro 372.");
      return;
    }

    if (!catalogo372) {
      showError(
        erroGovernanca372 ||
        "Governança do parâmetro 372 indisponível. A alteração foi bloqueada."
      );
      return;
    }

    if (!podeAlterar372) {
      showError(
        `Sem permissão para alterar o parâmetro 372. Necessário N${nivelMutacao372}; seu nível é N${normalizarNivelParametro(
          nivelParametroUsuario
        )}.`
      );
      return;
    }

    if (!permiteAlteracaoLote372) {
      showError("O parâmetro 372 não permite alteração em lote/global.");
      return;
    }

    setResultado(null);
    setBloqueioGlobal(null);
    setConfirmacaoGlobalOpen(true);
  };

  const fecharConfirmacaoGlobal = () => {
    if (aplicando) return;
    setConfirmacaoGlobalOpen(false);
  };

  const aplicarTodos = async () => {
  const valor = normalizarSimNao(valorTodos) || "Sim";

  if (!catalogo372 || !podeAlterar372) {
    showError(
      `Sem permissão para a alteração global. Necessário N${nivelMutacao372 ?? "?"}; seu nível é N${normalizarNivelParametro(
        nivelParametroUsuario
      )}.`
    );
    return;
  }

  if (!permiteAlteracaoLote372) {
    showError("O catálogo não permite alteração em lote para o parâmetro 372.");
    return;
  }

  const justificativa = S(justificativaGlobal);
  const confirmacao = S(confirmacaoGlobal);

  if (exigeJustificativa372 && !justificativa) {
    showError("Informe a justificativa da liberação global.");
    return;
  }

  if (exigeConfirmacao372 && confirmacao !== fraseConfirmacao372) {
    showError(
      `Confirmação textual inválida. Digite exatamente: ${fraseConfirmacao372}`
    );
    return;
  }

  garantirBearerApi();

  setAplicando(true);
  setResultado(null);
  setBloqueioGlobal(null);

  try {
    const { data } = await api.put(
      "/ssw/parametros-atualizacao-sistema/lote",
      {
        modo: "TODOS",
        vlParametro: valor,
        confirmarTodos: true,
        justificativa,
        textoConfirmacao: confirmacao,

        /*
         * No processamento global, o service gera sync somente
         * para registros que realmente mudarem.
         */
        gerarSyncMesmoValor: false,
      },
      {
        timeout: 180000,
      }
    );

    setConfirmacaoGlobalOpen(false);

    const resultadoAplicacao = {
      ok: data?.ok !== false,
      origem: "PARAMETRO_372_LOTE",
      parametro: data?.parametro || PARAMETRO_ATUALIZACAO,
      modo: data?.modo || "TODOS",
      execucao: data?.execucao || "MASSA_IDEMPOTENTE",

      totalRecebido: Number(data?.totalRecebido || 0),
      totalProcessado: Number(data?.totalProcessado || 0),
      totalAtualizado: Number(data?.totalAtualizado || 0),
      totalSyncGerado: Number(data?.totalSyncGerado || 0),
      totalIgnorado: Number(data?.totalIgnorado || 0),
      totalNaoEncontrado: Number(data?.totalNaoEncontrado || 0),
      totalErro: Number(data?.totalErro || 0),

      resultados: Array.isArray(data?.resultados)
        ? data.resultados
        : [],

      mensagem: data?.mensagem || null,
      respostaOriginal: data,
    };

    setResultado(resultadoAplicacao);

    showInfo(
      `Aplicação global concluída. Atualizados: ${resultadoAplicacao.totalAtualizado}. Sync: ${resultadoAplicacao.totalSyncGerado}.`
    );
  } catch (err) {
    const bloqueio = montarBloqueioJanelaGlobal(err);

    if (bloqueio) {
      setConfirmacaoGlobalOpen(false);
      setBloqueioGlobal(bloqueio);
      showError(bloqueio.message);
      return;
    }

    const msg = getMsgErroApi(
      err,
      "Falha ao aplicar o parâmetro 372 globalmente."
    );

    showError(msg);
  } finally {
    setAplicando(false);
  }
};

  return (
    <>
      <ReleasesModal
      open={open}
      onClose={onClose}
      title="Governança de Atualização do Sistema"
      icon={<MonitorUp size={20} />}
      className="releases-modal-wide atualizacao-sistema-modal"
    >
      <div className="update-hero">
        <div>
          <span className="eyebrow">Parâmetro 372 · Governança</span>
          <h3>Permitir sistema atualizar automaticamente?</h3>
          <p>
            Aplique via governança para computadores selecionados ou execute liberação global com auditoria, materialização e sync controlado.
          </p>
        </div>

        <div className="update-kpis">
          <div className="update-kpi">
            <strong>{totalLista}</strong>
            <span>na lista</span>
          </div>

          <div className="update-kpi success">
            <strong>{totalSim}</strong>
            <span>Sim</span>
          </div>

          <div className="update-kpi danger">
            <strong>{totalNao}</strong>
            <span>Não</span>
          </div>
        </div>
      </div>

      <div
        className={`governanca-access-strip ${
          podeAlterar372 ? "allowed" : "denied"
        }`}
      >
        <div className="governanca-access-main">
          {podeAlterar372 ? (
            <ShieldCheck size={18} />
          ) : (
            <ShieldOff size={18} />
          )}
          <div>
            <strong>Permissão para parâmetros</strong>
            <span>
              Seu nível: N{normalizarNivelParametro(nivelParametroUsuario)}
              {nivelMutacao372 != null
                ? ` · Parâmetro 372 exige N${nivelMutacao372}`
                : " · Consultando nível do parâmetro 372"}
            </span>
          </div>
        </div>

        <span className="governanca-access-status">
          {loadingGovernanca372
            ? "Carregando"
            : erroGovernanca372
              ? "Indisponível"
              : podeAlterar372
                ? "Autorizado"
                : "Sem permissão"}
        </span>
      </div>

      {erroGovernanca372 && (
        <div className="governanca-access-error">
          <AlertTriangle size={17} />
          <span>{erroGovernanca372}</span>
        </div>
      )}

      <div className="update-mode-bar">
        <button
          type="button"
          className={`mode-card ${
            modoAplicacao === "SELECIONADOS" ? "active" : ""
          }`}
          onClick={() => {
            setModoAplicacao("SELECIONADOS");
            setBloqueioGlobal(null);
          }}
        >
          <Users size={18} />
          <div>
            <strong>Clientes selecionados</strong>
            <span>Canário/teste em produção liberado a qualquer momento.</span>
          </div>
        </button>

        <button
          type="button"
          className={`mode-card danger ${
            modoAplicacao === "TODOS" ? "active" : ""
          }`}
          onClick={() => {
            setModoAplicacao("TODOS");
            setBloqueioGlobal(null);
          }}
        >
          <Globe2 size={18} />
          <div>
            <strong>Todos os computadores</strong>
            <span>Global permitido somente de segunda a quinta, 08:00 às 13:59.</span>
          </div>
        </button>
      </div>

      {modoAplicacao === "TODOS" && (
        <div className="global-update-box">
          <div className="global-update-info">
            <div className="global-icon">
              <AlertTriangle size={20} />
            </div>

            <div>
              <h4>Aplicação global</h4>
              <p>
  Esta ação altera o parâmetro <b>372</b> em todos os computadores
  cadastrados, atualiza o valor no legado e gera sync para cada
  registro efetivamente alterado.
  A liberação global é permitida somente de <b>segunda a quinta</b>,
  das <b>08:00 às 13:59</b>. Fora desse período, use
  <b> Clientes selecionados</b> para piloto ou teste controlado.
</p>
            </div>
          </div>

          <div className="global-update-actions">
            <label>
              Valor destino
              <select
                className="select-mini"
                value={valorTodos}
                onChange={(e) => setValorTodos(e.target.value)}
                disabled={aplicando}
              >
                <option value="Sim">Sim</option>
                <option value="Não">Não</option>
              </select>
            </label>

            <button
              type="button"
              className="btn danger"
              onClick={abrirConfirmacaoGlobal}
              disabled={
                aplicando ||
                loadingGovernanca372 ||
                !podeAlterar372 ||
                !permiteAlteracaoLote372
              }
            >
              {aplicando ? (
                <>
                  <Loader2 size={16} className="spin" />
                  Aplicando...
                </>
              ) : (
                <>
                  <Globe2 size={16} />
                  Aplicar global
                </>
              )}
            </button>
          </div>
        </div>
      )}

      {modoAplicacao === "TODOS" && bloqueioGlobal && (
        <div className="policy-alert-card">
          <div className="policy-alert-icon">
            <AlertTriangle size={22} />
          </div>

          <div className="policy-alert-content">
            <div className="policy-alert-header">
              <span className="policy-alert-eyebrow">Janela operacional</span>
              <strong>Liberação global bloqueada</strong>
            </div>

            <p>{bloqueioGlobal.message}</p>

            <div className="policy-alert-meta">
              <span>
                <b>Regra:</b> {TEXTO_JANELA_GLOBAL}
              </span>

              {bloqueioGlobal.janela && (
                <span>
                  <b>Agora:</b>{" "}
                  {formatarDetalheJanela(bloqueioGlobal.janela) || "—"}
                </span>
              )}
            </div>

            {bloqueioGlobal.permiteSelecionados && (
              <div className="policy-alert-action">
                <span>
                  Para piloto, homologação assistida ou correção pontual, use
                  clientes selecionados. Esse modo não possui bloqueio de horário.
                </span>

                <button
                  type="button"
                  className="btn ghost compact"
                  onClick={() => {
                    setModoAplicacao("SELECIONADOS");
                    setBloqueioGlobal(null);
                  }}
                >
                  <Users size={15} />
                  Ir para selecionados
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {modoAplicacao === "SELECIONADOS" && (
        <div className="update-grid">
          <section className="update-panel">
            <div className="update-panel-header">
              <div>
                <h4>
                  <Users size={17} />
                  Buscar cliente
                </h4>
                <p>
                  Localize o cliente e carregue as máquinas vinculadas. Este modo
                  não possui bloqueio por dia/horário.
                </p>
              </div>

              <button
                type="button"
                className="btn ghost compact"
                onClick={limparBusca}
              >
                <Eraser size={15} />
                Limpar
              </button>
            </div>

            <div className="update-select-row">
              <SelectCliente
                value={clienteSelecionado}
                onChange={handleClienteChange}
                includeInactiveSearch
                showTokenOnLabel={false}
                className="select-cliente update-select-cliente"
              />
            </div>

            <div className="update-panel-toolbar">
              <div className="mini-meta">
                {loadingComputadores ? (
                  <>
                    <Loader2 size={14} className="spin" />
                    Buscando computadores...
                  </>
                ) : (
                  <>
                    <MonitorUp size={14} />
                    {computadoresBusca.length} computador(es) encontrados
                  </>
                )}
              </div>

              <div className="quick-actions">
                <button
                  type="button"
                  className="btn ghost compact"
                  disabled={!computadoresBusca.length}
                  onClick={marcarTodosBusca}
                >
                  Marcar todos
                </button>

                <button
                  type="button"
                  className="btn ghost compact"
                  disabled={!computadoresBusca.length || !checkedKeys.length}
                  onClick={desmarcarTodosBusca}
                >
                  Desmarcar
                </button>
              </div>
            </div>

            <div className="bulk-destino">
              <span>Aplicar destino na busca:</span>

              <button
                type="button"
                className="btn success compact"
                disabled={!computadoresBusca.length}
                onClick={() => aplicarDestinoTodosBusca("Sim")}
              >
                Sim
              </button>

              <button
                type="button"
                className="btn danger compact"
                disabled={!computadoresBusca.length}
                onClick={() => aplicarDestinoTodosBusca("Não")}
              >
                Não
              </button>
            </div>

            <div className="update-table-wrap search-list">
              <table className="update-table">
                <thead>
                  <tr>
                    <th style={{ width: 44 }}></th>
                    <th>Computador</th>
                    <th>Identificador</th>
                    <th>Atual</th>
                    <th>Destino</th>
                  </tr>
                </thead>

                <tbody>
                  {loadingComputadores ? (
                    <tr>
                      <td colSpan={5}>
                        <div className="loading-row">
                          <Loader2 size={18} className="spin" />
                          Carregando computadores...
                        </div>
                      </td>
                    </tr>
                  ) : computadoresBusca.length === 0 ? (
                    <tr>
                      <td colSpan={5}>
                        <div className="empty-state small">
                          Selecione um cliente para listar os computadores.
                        </div>
                      </td>
                    </tr>
                  ) : (
                    computadoresBusca.map((item) => {
                      const key = chaveComputador372(item);
                      const checked = checkedKeys.includes(key);
                      const destino = normalizarSimNao(
                        destinosPorKey[key] || item.vlParametroDestino || "Sim"
                      );

                      return (
                        <tr key={key} className={checked ? "selected" : ""}>
                          <td>
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={() => toggleChecked(key)}
                            />
                          </td>

                          <td>
                            <div className="machine-cell">
                              <strong>{item.idComputador || "—"}</strong>
                              <small>
                                {item.nrLicenca}
                                {item.nrPdv ? ` • PDV ${item.nrPdv}` : ""}
                                {!item.ativo ? " • Inativo" : ""}
                              </small>
                            </div>
                          </td>

                          <td>{item.identificador || item.nomeComputador || "—"}</td>

                          <td>
                            <span
                              className={`simnao-badge ${classeSimNao(
                                item.valorAtual
                              )}`}
                            >
                              {item.valorAtual || "—"}
                            </span>
                          </td>

                          <td>
                            <select
                              className="select-mini"
                              value={destino}
                              onChange={(e) =>
                                alterarDestinoLinha(item, e.target.value)
                              }
                            >
                              <option value="Sim">Sim</option>
                              <option value="Não">Não</option>
                            </select>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            <div className="update-panel-footer">
              <span>{totalSelecionadosBusca} selecionado(s) nesta busca</span>

              <button
                type="button"
                className="btn primary"
                disabled={!checkedKeys.length}
                onClick={adicionarSelecionadosNaLista}
              >
                <Plus size={16} />
                Adicionar selecionados
              </button>
            </div>
          </section>

          <section className="update-panel cart-panel">
            <div className="update-panel-header">
              <div>
                <h4>
                  <ListChecks size={17} />
                  Lista de atualização
                </h4>
                <p>Computadores que serão enviados para atualização em lote.</p>
              </div>

              <button
                type="button"
                className="btn ghost compact"
                disabled={!itensAlteracao.length}
                onClick={limparLista}
              >
                <Trash2 size={15} />
                Limpar lista
              </button>
            </div>

            <div className="update-table-wrap cart-list">
              <table className="update-table">
                <thead>
                  <tr>
                    <th>Cliente</th>
                    <th>Computador</th>
                    <th>Atual</th>
                    <th>Destino</th>
                    <th style={{ width: 54 }}></th>
                  </tr>
                </thead>

                <tbody>
                  {itensAlteracao.length === 0 ? (
                    <tr>
                      <td colSpan={5}>
                        <div className="empty-state">
                          Nenhum computador adicionado. Pesquise um cliente,
                          marque as máquinas e clique em adicionar.
                        </div>
                      </td>
                    </tr>
                  ) : (
                    itensAlteracao.map((item) => {
                      const key = chaveComputador372(item);

                      return (
                        <tr key={key}>
                          <td>
                            <div className="client-cell">
                              <strong>{item.clienteNome || "Cliente"}</strong>
                              <small>{item.nrLicenca}</small>
                            </div>
                          </td>

                          <td>
                            <div className="machine-cell">
                              <strong>
                                {item.identificador || item.nomeComputador || "—"}
                              </strong>
                              <small>{item.idComputador}</small>
                            </div>
                          </td>

                          <td>
                            <span
                              className={`simnao-badge ${classeSimNao(
                                item.valorAtual
                              )}`}
                            >
                              {item.valorAtual || "—"}
                            </span>
                          </td>

                          <td>
                            <select
                              className="select-mini"
                              value={item.vlParametro}
                              onChange={(e) =>
                                alterarDestinoLista(item, e.target.value)
                              }
                            >
                              <option value="Sim">Sim</option>
                              <option value="Não">Não</option>
                            </select>
                          </td>

                          <td>
                            <button
                              type="button"
                              className="icon-btn danger"
                              onClick={() => removerItemLista(item)}
                              title="Remover da lista"
                            >
                              <Trash2 size={15} />
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            <div className="governanca-inline-box">
              <div className="governanca-inline-head">
                <strong>Alteração governada</strong>
                <span>
                  Parâmetro N{nivelMutacao372 ?? "?"} · escopo COMPUTADOR
                </span>
              </div>

              <div className="governanca-inline-fields">
                <label>
                  Justificativa operacional
                  <textarea
                    value={justificativaSelecionados}
                    onChange={(e) => setJustificativaSelecionados(e.target.value)}
                    disabled={aplicando || !exigeJustificativa372}
                    placeholder={
                      exigeJustificativa372
                        ? "Informe o motivo da liberação para os computadores selecionados."
                        : "Este parâmetro não exige justificativa."
                    }
                  />
                </label>

                <label>
                  Confirmação textual
                  <input
                    type="text"
                    value={confirmacaoSelecionados}
                    onChange={(e) => setConfirmacaoSelecionados(e.target.value)}
                    disabled={aplicando || !exigeConfirmacao372}
                  />
                  <small>
                    {exigeConfirmacao372
                      ? `Digite exatamente: ${fraseConfirmacao372}`
                      : "Este parâmetro não exige confirmação textual."}
                  </small>
                </label>
              </div>
            </div>

            <div className="update-panel-footer sticky">
              <div className="final-summary">
                <strong>{itensAlteracao.length}</strong>
                <span>computador(es) na operação</span>
              </div>

              <button
                type="button"
                className="btn primary"
                disabled={
                  !itensAlteracao.length ||
                  aplicando ||
                  loadingGovernanca372 ||
                  !podeAlterar372
                }
                onClick={aplicarSelecionados}
              >
                {aplicando ? (
                  <>
                    <Loader2 size={16} className="spin" />
                    Aplicando...
                  </>
                ) : (
                  <>
                    <Save size={16} />
                    Aplicar alterações
                  </>
                )}
              </button>
            </div>
          </section>
        </div>
      )}

      {resultado && (
        <div className="resultado-box resultado-box-global">
          <div className="resultado-header">
            <CheckCircle2 size={18} />
            <strong>Resultado da aplicação</strong>
          </div>

          <div className="resultado-kpis">
            <span>
              Recebidos: <b>{resultado.totalRecebido ?? 0}</b>
            </span>
            <span>
              Processados: <b>{resultado.totalProcessado ?? 0}</b>
            </span>
            <span>
              Atualizados: <b>{resultado.totalAtualizado ?? 0}</b>
            </span>
            <span>
              Sync: <b>{resultado.totalSyncGerado ?? 0}</b>
            </span>
            <span>
              Erros: <b>{resultado.totalErro ?? 0}</b>
            </span>
          </div>

          {Array.isArray(resultado.resultados) &&
            resultado.resultados.length > 0 && (
              <div className="resultado-list">
                {resultado.resultados.slice(0, 12).map((r, idx) => (
                  <div
                    key={`${r.nrLicenca}-${r.idComputador}-${idx}`}
                    className={`resultado-item ${
                      r.status === "ERRO" ? "erro" : "ok"
                    }`}
                  >
                    <span>{r.nrLicenca}</span>
                    <span>{r.status}</span>
                    <span>Sync: {r.syncId || "—"}</span>
                  </div>
                ))}

                {resultado.resultados.length > 12 && (
                  <small>
                    Exibindo 12 de {resultado.resultados.length} resultado(s).
                  </small>
                )}
              </div>
            )}
        </div>
      )}
      </ReleasesModal>

      <ReleasesModal
        open={confirmacaoGlobalOpen}
        onClose={fecharConfirmacaoGlobal}
        title="Confirmar governança global"
        icon={<AlertTriangle size={20} />}
        className="confirmacao-global-modal"
      >
        <div className="confirm-global-hero">
          <div className="confirm-global-icon">
            <Globe2 size={26} />
          </div>

          <div>
            <span>Operação crítica</span>
            <h3>Aplicar parâmetro 372 via governança global?</h3>
            <p>
              Esta ação valida nível, escopo, permissão de lote e janela operacional, atualiza o valor no legado e cria/reutiliza sincronização pendente para os computadores impactados.
            </p>
          </div>
        </div>

        <div className="confirm-global-grid">
          <div className="confirm-global-item">
            <small>Valor destino</small>
            <strong>{normalizarSimNao(valorTodos) || "Sim"}</strong>
          </div>

          <div className="confirm-global-item">
            <small>Escopo</small>
            <strong>Todos os computadores</strong>
          </div>

          <div className="confirm-global-item">
            <small>Janela permitida</small>
            <strong>{TEXTO_JANELA_GLOBAL}</strong>
          </div>
        </div>

        <div className="confirm-global-policy">
          <AlertTriangle size={18} />
          <p>
            Fora da janela operacional, a API bloqueará a liberação global. Para
            teste controlado fora desse período, use <b>Clientes selecionados</b>.
          </p>
        </div>

        <div className="governanca-inline-box global-confirm-governanca">
          <div className="governanca-inline-head">
            <strong>Confirmação de governança</strong>
            <span>Parâmetro N{nivelMutacao372 ?? "?"} · escopo GLOBAL</span>
          </div>

          <div className="governanca-inline-fields single">
            <label>
              Justificativa operacional
              <textarea
                value={justificativaGlobal}
                onChange={(e) => setJustificativaGlobal(e.target.value)}
                disabled={aplicando || !exigeJustificativa372}
                placeholder={
                  exigeJustificativa372
                    ? "Informe o motivo da liberação global."
                    : "Este parâmetro não exige justificativa."
                }
              />
            </label>

            <label>
              Confirmação textual
              <input
                type="text"
                value={confirmacaoGlobal}
                onChange={(e) => setConfirmacaoGlobal(e.target.value)}
                disabled={aplicando || !exigeConfirmacao372}
              />
              <small>
                {exigeConfirmacao372
                  ? `Digite exatamente: ${fraseConfirmacao372}`
                  : "Este parâmetro não exige confirmação textual."}
              </small>
            </label>
          </div>
        </div>

        <div className="releases-modal-footer confirm-global-footer">
          <button
            type="button"
            className="btn ghost"
            onClick={fecharConfirmacaoGlobal}
            disabled={aplicando}
          >
            Cancelar
          </button>

          <button
            type="button"
            className="btn danger"
            onClick={aplicarTodos}
            disabled={
              aplicando ||
              !podeAlterar372 ||
              !permiteAlteracaoLote372
            }
          >
            {aplicando ? (
              <>
                <Loader2 size={16} className="spin" />
                Aplicando...
              </>
            ) : (
              <>
                <Globe2 size={16} />
                Confirmar governança global
              </>
            )}
          </button>
        </div>
      </ReleasesModal>
    </>
  );
}

export default function ReleasesTestes() {
  const userName = getUserNameFromStorage();
  const nivelParametroUsuario = getNivelParametroFromStorage();

  useEffect(() => {
    garantirBearerApi();
  }, []);

  const [helpOpen, setHelpOpen] = useState(false);
  const [atualizacaoModalOpen, setAtualizacaoModalOpen] = useState(false);

  const { initial, setMany } = useQuerySync({
    produto: "SPW",
    q: "",
    status: "",
    onlyActive: false,
    page: 1,
    limit: 20,
    sort: "VERSAO_COD:desc",
  });

  const [produto, setProduto] = useState(initial.produto || "SPW");
  const [q, setQ] = useState(initial.q);
  const [status, setStatus] = useState(initial.status);
  const [onlyActive, setOnlyActive] = useState(initial.onlyActive);
  const [page, setPage] = useState(initial.page);
  const [limit, setLimit] = useState(initial.limit);
  const [sort, setSort] = useState(initial.sort);

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const [error, setError] = useState("");

  const [qDebounced, setQDebounced] = useState(q);

  useEffect(() => {
    const id = setTimeout(() => setQDebounced(q), 350);
    return () => clearTimeout(id);
  }, [q]);

  const buildParams = useCallback(() => {
    const p = {};

    if (produto) p.produto = produto;
    if (qDebounced && qDebounced.trim() !== "") p.q = qDebounced.trim();
    if (status && status.trim() !== "") p.status = status.trim();
    if (onlyActive) p.onlyActive = 1;
    if (page) p.page = page;
    if (limit) p.limit = limit;
    if (sort && sort.trim() !== "") p.sort = sort.trim();

    return p;
  }, [produto, qDebounced, status, onlyActive, page, limit, sort]);

  const doLoad = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const params = buildParams();
      const { data } = await api.get("/releases", { params });
      const norm = normalizeResult(data);

      setRows(norm.rows);
      setTotal(norm.total);
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.response?.data?.mensagem ||
        err?.message ||
        "Falha ao carregar releases.";

      setError(msg);
      showError(msg);
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
      setFirstLoad(false);
    }
  }, [buildParams]);

  useEffect(() => {
    setMany(buildParams());
    doLoad();
  }, [
    produto,
    qDebounced,
    status,
    onlyActive,
    page,
    limit,
    sort,
    doLoad,
    setMany,
    buildParams,
  ]);

  useEffect(() => {
    const onKey = (e) => {
      const tag = (e.target?.tagName || "").toLowerCase();
      const isField = ["input", "select", "textarea"].includes(tag);

      if (e.key === "?" && !isField) {
        e.preventDefault();
        setHelpOpen((v) => !v);
      }

      if (e.key === "/" && !isField) {
        e.preventDefault();
        const el = document.querySelector(
          '.releases-toolbar input[type="search"]'
        );
        el?.focus();
      }

      if (e.key.toLowerCase() === "r" && !isField) {
        e.preventDefault();
        doLoad();
      }
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [doLoad]);

  const onSubmitSearch = (e) => {
    e.preventDefault();
    setPage(1);
    doLoad();
  };

  const resetFilters = () => {
    setQ("");
    setStatus("");
    setOnlyActive(false);
    setPage(1);
    setSort("UPLOADED_AT:desc");
  };

  const toggleSort = (col) => {
    const [curCol, curDir] = String(sort).split(":");
    const nextDir =
      curCol === col && (curDir || "").toLowerCase() === "asc" ? "desc" : "asc";

    setSort(`${col}:${nextDir}`);
    setPage(1);
  };

  const isSorted = (col) => String(sort).startsWith(`${col}:`);
  const sortedDir = (col) =>
    isSorted(col) ? String(sort).split(":")[1] : undefined;

  const handleDownload = async (row) => {
    const id = row?.id || row?.ID || row?.ID_RELEASE;

    if (!id) {
      showError("Release sem identificador para download.");
      return;
    }

    try {
      garantirBearerApi();

      const { data } = await api.get(
        `/ssw/releases/${encodeURIComponent(id)}/download-url`
      );

      const downloadUrl = data?.downloadUrl;

      if (!downloadUrl) {
        throw new Error("URL de download não retornada pela API.");
      }

      window.open(downloadUrl, "_blank", "noopener");
    } catch (err) {
      console.error("[RELEASE][DOWNLOAD]", err);

      showError(
        err?.response?.data?.message ||
          err?.response?.data?.mensagem ||
          err?.response?.data?.error ||
          err?.message ||
          "Não foi possível baixar o release."
      );
    }
  };

  const [testModalOpen, setTestModalOpen] = useState(false);
  const [testModalOutcome, setTestModalOutcome] = useState(null);
  const [testModalRow, setTestModalRow] = useState(null);
  const [testModalObs, setTestModalObs] = useState("");

  const [activateModalOpen, setActivateModalOpen] = useState(false);
  const [activateRow, setActivateRow] = useState(null);

  const openTestModal = (row, outcome) => {
    const rowProduto = (row?.produto || row?.PRODUTO || produto || "").toUpperCase();

    if (rowProduto === "DLL") {
      showInfo("DLL não exige aprovação/reprovação. Ative diretamente em produção.");
      return;
    }

    if (!row?.id && !row?.ID && !row?.ID_RELEASE) {
      showError("Release sem identificador para teste.");
      return;
    }

    const obs = row.obs_teste || row.OBS_TESTE || "";

    setTestModalRow(row);
    setTestModalOutcome(outcome);
    setTestModalObs(obs);
    setTestModalOpen(true);
  };

  const handleConfirmMarcarTeste = async () => {
    if (!testModalRow || !testModalOutcome) return;

    const row = testModalRow;
    const outcome = testModalOutcome;
    const id = row.id || row.ID || row.ID_RELEASE;

    if (!id) {
      showError("Release sem identificador para teste.");
      return;
    }

    const label = outcome === "APROVADO" ? "APROVADO" : "REPROVADO";
    const obs =
      (testModalObs || "").trim() || "Teste realizado via tela de releases.";

    try {
      await api.patch(`/releases/${id}/status`, {
        status: outcome,
        obs_teste: obs,
        testado_por: userName || "Sistema",
      });

      showInfo(`Status de teste marcado como ${label}.`);
      setTestModalOpen(false);
      setTestModalRow(null);
      setTestModalOutcome(null);
      setTestModalObs("");
      doLoad();
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.response?.data?.mensagem ||
        err?.message ||
        `Falha ao marcar como ${label}.`;

      showError(msg);
    }
  };

  const openActivateModal = (row) => {
    if (!row?.id && !row?.ID && !row?.ID_RELEASE) {
      showError("Release sem identificador para ativação.");
      return;
    }

    setActivateRow(row);
    setActivateModalOpen(true);
  };

  const handleConfirmAtivarProducao = async () => {
    if (!activateRow) return;

    const row = activateRow;
    const id = row.id || row.ID || row.ID_RELEASE;

    if (!id) {
      showError("Release sem identificador para ativação.");
      return;
    }

    try {
      await api.post(`/releases/${id}/ativar`, {
        obrigatoria: false,
        dataHoraLiberacao: new Date().toISOString(),
        usuario: userName || "Sistema",
      });

      showInfo("Release ativado em produção com sucesso.");
      setActivateModalOpen(false);
      setActivateRow(null);
      doLoad();
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.response?.data?.mensagem ||
        err?.message ||
        "Falha ao ativar release em produção.";

      showError(msg);
    }
  };

  const canActivateByRule = (rowProduto, ativa, statusValue) => {
    const p = String(rowProduto || "").toUpperCase();

    if (ativa) return false;
    if (p === "DLL") return true;

    return String(statusValue || "").toUpperCase() === "APROVADO";
  };

  return (
    <MainLayout>
      <div className="releases-page">
        <div className="releases-toolbar">
          <div className="status-pills" aria-label="Produto">
            {RELEASE_PRODUTOS.map((p) => (
              <button
                key={p.key}
                type="button"
                className={`pill ${
                  String(produto).toUpperCase() === p.key ? "active" : ""
                }`}
                onClick={() => {
                  setProduto(p.key);
                  setPage(1);
                }}
                title={`Produto: ${p.label}`}
              >
                {p.label}
              </button>
            ))}
          </div>

          <form
            className="releases-filters"
            onSubmit={onSubmitSearch}
            role="search"
            aria-label="Filtrar releases"
            title="Use / para focar a busca"
          >
            <div
              className="input-icon"
              title="Buscar por versão, autor ou notas. Atalho: /"
            >
              <Search size={16} />
              <input
                type="search"
                placeholder="Buscar (versão, autor, notas)"
                value={q}
                onChange={(e) => {
                  setQ(e.target.value);
                  setPage(1);
                }}
                autoComplete="off"
                aria-label="Buscar releases"
              />
            </div>

            <div className="status-pills" aria-label="Status de teste">
              <button
                type="button"
                className={`pill ${status === "" ? "active" : ""}`}
                onClick={() => {
                  setStatus("");
                  setPage(1);
                }}
                title="Todos os status"
              >
                Todos
              </button>

              {StatusOpts.map((s) => (
                <button
                  key={s}
                  type="button"
                  className={`pill ${status === s ? "active" : ""}`}
                  onClick={() => {
                    setStatus(s);
                    setPage(1);
                  }}
                  title={`Filtrar por ${s}`}
                >
                  {s}
                </button>
              ))}
            </div>

            <label
              className="check-flag"
              title="Mostrar apenas releases ativos em produção"
            >
              <input
                type="checkbox"
                checked={!!onlyActive}
                onChange={(e) => {
                  setOnlyActive(e.target.checked);
                  setPage(1);
                }}
              />
              <span>Somente produção</span>
            </label>

            <button
              type="submit"
              className="btn solid"
              aria-label="Aplicar filtros"
              title="Aplicar filtros (Enter)"
            >
              Filtrar
            </button>

            <button
              type="button"
              className="btn ghost"
              onClick={resetFilters}
              aria-label="Limpar filtros"
              title="Limpar filtros"
            >
              Limpar
            </button>
          </form>

          <div className="releases-actions">
            <button
              className="btn ghost"
              onClick={doLoad}
              aria-label="Atualizar lista"
              title="Atualizar (atalho: r)"
            >
              <RefreshCw size={16} />
              <span>Atualizar</span>
            </button>

            <button
              className="btn primary"
              onClick={() => setAtualizacaoModalOpen(true)}
              aria-label="Liberação de atualização do sistema"
              title={
                nivelParametroUsuario > 0
                  ? `Abrir governança do parâmetro 372 · seu nível N${nivelParametroUsuario}`
                  : "Seu usuário não possui nível para alteração de parâmetros"
              }
              disabled={nivelParametroUsuario <= 0}
            >
              <MonitorUp size={16} />
              <span>Liberar atualização</span>
              <span className="btn-level-chip">N{nivelParametroUsuario}</span>
            </button>

            <button
              className="btn ghost"
              onClick={() => setHelpOpen(true)}
              aria-label="Ajuda"
              title="Ajuda (atalho: ?)"
            >
              <HelpCircle size={16} />
              <span>Ajuda</span>
            </button>
          </div>
        </div>

        <HelpBar>
          <b>Como usar:</b> esta tela é o hub de <i>testes</i> e{" "}
          <i>promoção para produção</i>. Use as abas para separar por produto.
          Para <b>SPW/VB6</b>, só é permitido ativar em produção após{" "}
          <b>APROVADO</b>. Para <b>DLL</b>, a ativação em produção independe de
          aprovação. Atalhos: <code>/</code> buscar, <code>r</code> atualizar,{" "}
          <code>?</code> ajuda.
        </HelpBar>

        <div className="releases-content" aria-live="polite" aria-busy={loading}>
          {firstLoad && loading && (
            <div className="card">
              <div className="card-header">
                <Skeleton width={220} height={20} />
              </div>

              <div className="card-body">
                <Skeleton height={28} count={1} style={{ marginBottom: 12 }} />
                <Skeleton height={40} count={8} />
              </div>
            </div>
          )}

          {!firstLoad && error && (
            <div className="card error">
              <div className="card-body">
                <p>{error}</p>

                <button className="btn primary" onClick={doLoad}>
                  Tentar novamente
                </button>
              </div>
            </div>
          )}

          {!firstLoad && !loading && !error && (
            <>
              <div className="meta-row">
                <span>
                  {total > 0
                    ? `Exibindo ${rows?.length || 0} de ${total} releases`
                    : "Nenhum release encontrado"}
                </span>
              </div>

              {rows.length === 0 ? (
                <div className="card empty">
                  <div className="card-body">
                    <h3>Nenhum release encontrado</h3>
                    <p>Suba um novo arquivo via card de Releases na barra lateral.</p>
                  </div>
                </div>
              ) : (
                <div className="table-wrap">
                  <table className="table releases-table">
                    <thead>
                      <tr>
                        <th
                          role="button"
                          onClick={() => toggleSort("VERSAO")}
                          className={isSorted("VERSAO") ? "sorted" : ""}
                          title="Ordenar por versão"
                        >
                          Versão{" "}
                          <ArrowUpDown
                            className={`sort ${sortedDir("VERSAO")}`}
                            size={14}
                          />
                        </th>

                        <th>Status</th>
                        <th>Produção</th>

                        <th
                          role="button"
                          onClick={() => toggleSort("AUTOR")}
                          className={isSorted("AUTOR") ? "sorted" : ""}
                          title="Ordenar por autor"
                        >
                          Autor{" "}
                          <ArrowUpDown
                            className={`sort ${sortedDir("AUTOR")}`}
                            size={14}
                          />
                        </th>

                        <th
                          role="button"
                          onClick={() => toggleSort("UPLOADED_AT")}
                          className={isSorted("UPLOADED_AT") ? "sorted" : ""}
                          title="Ordenar por data de upload"
                        >
                          Enviado em{" "}
                          <ArrowUpDown
                            className={`sort ${sortedDir("UPLOADED_AT")}`}
                            size={14}
                          />
                        </th>

                        <th>Tamanho</th>
                        <th>Último teste</th>
                        <th>Testado por</th>
                        <th>Obs. teste</th>
                        <th>Ações</th>
                      </tr>
                    </thead>

                    <tbody>
                      {rows.map((r) => {
                        const id = r.id || r.ID || r.ID_RELEASE;
                        const versao = r.versao || r.VERSAO;
                        const ativa = !!(r.ativa || r.ATIVA);
                        const statusValue = r.status || r.STATUS || "EM_TESTE";
                        const uploadedAt =
                          r.uploaded_at ||
                          r.UPLOADED_AT ||
                          r.created_at ||
                          r.CREATED_AT;
                        const fileSize = r.file_size || r.FILE_SIZE || r.tamanho;
                        const testeEm =
                          r.testado_em || r.TESTADO_EM || r.ultima_execucao;
                        const testadoPor = r.testado_por || r.TESTADO_POR || "";
                        const obsTeste = r.obs_teste || r.OBS_TESTE || "";
                        const rowProduto = (
                          r.produto ||
                          r.PRODUTO ||
                          produto ||
                          ""
                        ).toUpperCase();

                        const isDll = rowProduto === "DLL";

                        const canAprovar =
                          !isDll &&
                          String(statusValue).toUpperCase() !== "APROVADO";
                        const canReprovar =
                          !isDll &&
                          String(statusValue).toUpperCase() !== "REPROVADO";
                        const canAtivar = canActivateByRule(
                          rowProduto,
                          ativa,
                          statusValue
                        );

                        return (
                          <tr key={id || versao}>
                            <td>
                              <span className="mono">{versao || "—"}</span>
                            </td>

                            <td>
                              <StatusBadge value={statusValue} />
                            </td>

                            <td>
                              <ActiveBadge ativa={ativa} />
                            </td>

                            <td>{r.autor || r.AUTOR || "—"}</td>
                            <td>{fmtDateTime(uploadedAt)}</td>
                            <td>{fmtBytes(fileSize)}</td>
                            <td>{fmtDateTime(testeEm)}</td>
                            <td>{testadoPor || "—"}</td>

                            <td>
                              {obsTeste ? (
                                <span className="obs-teste" title={obsTeste}>
                                  {obsTeste.length > 40
                                    ? `${obsTeste.slice(0, 40)}…`
                                    : obsTeste}
                                </span>
                              ) : (
                                "—"
                              )}
                            </td>

                            <td>
                              <div className="actions-col">
                                <button
                                  type="button"
                                  className="icon-btn"
                                  onClick={() => handleDownload(r)}
                                  title="Baixar arquivo deste release"
                                >
                                  <Download size={16} />
                                </button>

                                {canAprovar && (
                                  <button
                                    type="button"
                                    className="icon-btn ok"
                                    onClick={() => openTestModal(r, "APROVADO")}
                                    title="Marcar como APROVADO nos testes"
                                  >
                                    <ShieldCheck size={16} />
                                  </button>
                                )}

                                {canReprovar && (
                                  <button
                                    type="button"
                                    className="icon-btn warn"
                                    onClick={() => openTestModal(r, "REPROVADO")}
                                    title="Marcar como REPROVADO nos testes"
                                  >
                                    <ShieldOff size={16} />
                                  </button>
                                )}

                                {canAtivar && (
                                  <button
                                    type="button"
                                    className="icon-btn danger"
                                    onClick={() => openActivateModal(r)}
                                    title={
                                      isDll
                                        ? "Ativar DLL em produção (não depende de aprovação)"
                                        : "Ativar em produção (somente após APROVADO)"
                                    }
                                  >
                                    <AlertTriangle size={16} />
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}

              {rows.length > 0 && (
                <div className="pager">
                  <button
                    className="btn ghost"
                    disabled={page <= 1}
                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                    aria-label="Página anterior"
                    title="Página anterior"
                  >
                    <ChevronLeft size={16} />
                    Anterior
                  </button>

                  <span className="page-indicator">pág. {page}</span>

                  <button
                    className="btn ghost"
                    disabled={page * limit >= total}
                    onClick={() => setPage((p) => p + 1)}
                    aria-label="Próxima página"
                    title="Próxima página"
                  >
                    Próxima
                    <ChevronRight size={16} />
                  </button>

                  <select
                    value={limit}
                    onChange={(e) => {
                      const v = Number(e.target.value);
                      setLimit(v);
                      setPage(1);
                    }}
                    aria-label="Itens por página"
                    className="select-compact"
                    title="Itens por página"
                  >
                    {[10, 20, 50, 100].map((n) => (
                      <option key={n} value={n}>
                        {n}/pág.
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <AtualizacaoSistemaModal
        open={atualizacaoModalOpen}
        onClose={() => setAtualizacaoModalOpen(false)}
        nivelParametroUsuario={nivelParametroUsuario}
      />

      <HelpModal open={helpOpen} onClose={() => setHelpOpen(false)}>
        <h2>Ajuda – Tela de Testes de Releases</h2>
        <p>Esta tela centraliza a visibilidade e o fluxo de releases por produto.</p>

        <ul>
          <li>
            Use as <b>abas</b> para alternar entre SPW, VB6 e DLL.
          </li>

          <li>
            Para <b>SPW/VB6</b>, o fluxo é: <b>testar</b> → <b>aprovar</b> →{" "}
            <b>ativar em produção</b>.
          </li>

          <li>
            Para <b>DLL</b>, <b>não há gate de aprovação</b>: é possível ativar
            em produção diretamente.
          </li>

          {nivelParametroUsuario > 0 && (
            <li>
              O botão <b>Liberar atualização</b> usa seu <b>Nível de Parâmetros N{nivelParametroUsuario}</b>.
              A API compara esse nível com o NIVEL_MUTACAO do parâmetro 372.
              Clientes selecionados podem ser liberados conforme a governança;
              a liberação global também exige permissão de lote e janela operacional.
            </li>
          )}

          <li>
            Atalhos: <code>/</code> buscar, <code>r</code> atualizar,{" "}
            <code>?</code> ajuda.
          </li>
        </ul>
      </HelpModal>

      <ReleasesModal
        open={testModalOpen}
        onClose={() => setTestModalOpen(false)}
        title={
          testModalOutcome === "APROVADO"
            ? "Confirmar aprovação nos testes"
            : "Confirmar reprovação nos testes"
        }
        icon={
          testModalOutcome === "APROVADO" ? (
            <CheckCircle2 size={20} />
          ) : (
            <XCircle size={20} />
          )
        }
      >
        {testModalRow && (
          <>
            <p className="modal-subtitle">
              Versão:{" "}
              <span className="mono">
                {testModalRow.versao || testModalRow.VERSAO || "—"}
              </span>
            </p>

            <div className="field">
              <label>Descrição / Observações do teste</label>

              <textarea
                rows={4}
                value={testModalObs}
                onChange={(e) => setTestModalObs(e.target.value)}
                placeholder="Descreva rapidamente o cenário testado, ambiente e resultado."
              />
            </div>
          </>
        )}

        <div className="releases-modal-footer">
          <button
            type="button"
            className="btn ghost"
            onClick={() => setTestModalOpen(false)}
          >
            Cancelar
          </button>

          <button
            type="button"
            className={testModalOutcome === "APROVADO" ? "btn primary" : "btn danger"}
            onClick={handleConfirmMarcarTeste}
          >
            {testModalOutcome === "APROVADO"
              ? "Marcar como APROVADO"
              : "Marcar como REPROVADO"}
          </button>
        </div>
      </ReleasesModal>

      <ReleasesModal
        open={activateModalOpen}
        onClose={() => setActivateModalOpen(false)}
        title="Ativar release em produção"
        icon={<AlertTriangle size={20} />}
      >
        {activateRow && (
          <>
            <p>
              Confirma ativar este release em <b>PRODUÇÃO</b>?
            </p>

            <ul className="modal-list">
              <li>
                Versão:{" "}
                <span className="mono">
                  {activateRow.versao || activateRow.VERSAO || "—"}
                </span>
              </li>

              <li>Autor: {activateRow.autor || activateRow.AUTOR || "—"}</li>

              <li>
                Tamanho:{" "}
                {fmtBytes(
                  activateRow.file_size ||
                    activateRow.FILE_SIZE ||
                    activateRow.tamanho
                )}
              </li>
            </ul>

            <p className="modal-warning">
              Os clientes passarão a receber esta versão no próximo check automático do PDV.
            </p>
          </>
        )}

        <div className="releases-modal-footer">
          <button
            type="button"
            className="btn ghost"
            onClick={() => setActivateModalOpen(false)}
          >
            Cancelar
          </button>

          <button
            type="button"
            className="btn danger"
            onClick={handleConfirmAtivarProducao}
          >
            Ativar em produção
          </button>
        </div>
      </ReleasesModal>
    </MainLayout>
  );
}